module.exports = __webpack_public_path__ + "static/img/cabinet12_2.65273e60.gif";